import React from 'react';

const EditTemplate: React.FC = (props) => {
  return <div className='vod_ctrl'>{props.children}</div>;
};

export default EditTemplate;
